export default {
  enquirySettings: {
    addEmail: {
      email: "Add an email address",
      add: "Add",
      invalidMessage:
        "To add a new enquiry contact you must use a valid email address.",
      title: "Enquiry Settings",
      description:
        "Manage the team members that will receive all listing enquires from this account. You can include a maximum of {maximum} email addesses.",
    },
    emailList: {
      title: "Team members to receive listing enquiries",
      counter:
        "You can add <strong>{number}</strong> additional team members\n",
      noEmailsTip: {
        title:
          "There are no other members set to receive equiries for this account ",
        text: "Simply add the email address in the field above for any additional members.",
      },
      remove: "Remove from enquiry list",
    },
  },
};
